module.exports = __webpack_public_path__ + "img/preliminary-service.f4deca5a.jpg";